import {publish} from './queue.js';

export const publishTrigger = (track, trigger) => {
    let type = (track.trackNumber + 1) +
        track.subSequence.name.toLowerCase() + '.trigger';
    publish(type, trigger.stepData);
};

export const publishRoll = (rolling, resolution, isTriplet) => {
    let type = "roll";
    publish(type, {rolling, resolution, isTriplet});
};

export const publishPatternSwitch= (subSequence, patternNumber) => {
    // publish 2 messages:
    // 1 message specific to the sub sequence,
    // and a more generalized one for any pattern switch
    let type = "pattern-switch." + subSequence.name;
    publish(type, patternNumber + 1);
    type = "pattern-switch";
    publish(type, patternNumber + 1);
};

export const publishPlanarBounce = (horizontal) => {
    let type = "planar-bounce";
    publish(type, horizontal);
};

export const publishPlanarSnapshot = (snapshot) => {
    let type = "planar-snapshot";
    publish(type, snapshot);
};

// what notes are currently playing
export const publishNotesDown = (notes) => {
    let type = "notes-down";
    publish(type, notes);
};

// what notes are currently playing
export const publishTriggerCount = (count) => {
    let type = "trigger-count";
    publish(type, count);
};


